import { render, staticRenderFns } from "./RowColaborador.vue?vue&type=template&id=693ff8d5"
import script from "./RowColaborador.vue?vue&type=script&lang=js"
export * from "./RowColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports